export type Color = string;
export interface Colors {
  white_black: Color;
}

/** 整站暖色插画风 token（与画布 V2 方案一致） */
export const WARM = {
  pageBg: "#FDF8EC", // 页面底 · 奶油
  bannerBg: "#FBF1DC", // Banner 底 · 稍深奶油
  cardBg: "#FFFFFF", // 卡片底
  cardBorder: "#EBD9B0", // 卡片描边
  ink: "#3A2E22", // 墨色 · 标题/主文字
  body: "#6E5D49", // 正文灰棕
  meta: "#A89A80", // 次级信息
  accent: "#D96438", // 陶橙 · 主强调
  accentDeep: "#B0512B", // 深陶橙 · 印章/链接
  mustard: "#E8B23A", // 芥末黄 · 装饰
  chipBg: "#F3E5C8", // tag chip 未选底
  chipText: "#6E5D49", // tag chip 未选字
} as const;

export function colors(darkMode: boolean): Colors {
  return {
    white_black: darkMode ? "#FFFFFF" : "#222222",
  };
}
